import React from 'react';
import { css } from '@emotion/css';
import { classNames } from '../utils/class-name';

type Props = {
  element?: keyof JSX.IntrinsicElements;
  children?: React.ReactNode;
  style?: React.CSSProperties;
  className?: string;
};

export default function Expanded(props: Props) {
  const { element, className, ...rest } = props;
  const Element = element || 'div';
  return (
    <Element {...rest} className={classNames(expandedCss,className)} />
  );
}

const expandedCss = css`
  flex: 1;
`;
